import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import 'bootstrap/dist/css/bootstrap.min.css'

import { Routes } from 'routes'
import { store } from 'store'

import { Notification } from 'types/notifications'

import { socketNotifications } from 'requests/socket'
import { mapSocketNotificationToFe } from 'requests/notifications'

import { showChatNotifications } from 'utils/browser-notifications'
import { isNotificationsModuleEnabled } from 'utils/is-notifications-module-enabled'
import { notificationsUpdateSuccess } from 'store/notifications/notifications.actions'

import { AppTabTitle } from 'components/global/AppTabTitle'
import { CustomerOrderStatusMonitor } from 'components/global/CustomerOrderStatusMonitor'
import { InboxNotificationsMonitor } from 'components/global/InboxNotificationsMonitor'
import Alert from 'components/molecules/Alert'
import GlobalErrorAlert from 'components/molecules/GlobalErrorAlert'
import GlobalPaymentStateAlert from 'components/molecules/GlobalPaymentStateAlert'
import GlobalOtkIdAlert from 'components/molecules/GlobalOtkIdAlert'
import ServiceStatusBanner from 'components/global/ServiceStatusBanner'

import './global-styles.css'

const lastChatNotificationAtByOrderId: Record<string, number> = {}

const emitBrowserChatNotifications = (normalized: Notification[]) => {
  const newItems = normalized.filter((it) => {
    if (!it.orderId) return false
    const ts = Date.parse(it.createdAt)
    if (!Number.isFinite(ts)) return false

    const prevTs = lastChatNotificationAtByOrderId[it.orderId] ?? 0
    if (ts <= prevTs) return false
    return true
  })

  if (newItems.length) {
    newItems.forEach((it) => {
      const ts = Date.parse(it.createdAt)
      if (Number.isFinite(ts)) lastChatNotificationAtByOrderId[it.orderId] = ts
    })
    showChatNotifications({ items: newItems })
  }
}

// Legacy: chat-be Socket.IO push only when module flag is off.
if (!isNotificationsModuleEnabled()) {
  socketNotifications.on('notifications', (data: Notification[]) => {
    const normalized = (data || []).map((item) => mapSocketNotificationToFe(item))
    emitBrowserChatNotifications(normalized)
    store.dispatch(notificationsUpdateSuccess(normalized))
  })
}

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <InboxNotificationsMonitor />
      <CustomerOrderStatusMonitor />
      <AppTabTitle />
      <div
        className="position-relative page"
        onDrop={(event) => {
          event.preventDefault()
          event.stopPropagation()
        }}
        onDragOver={(event) => {
          event.preventDefault()
          event.stopPropagation()
        }}
      >
        <ServiceStatusBanner />
        <GlobalErrorAlert />
        <GlobalPaymentStateAlert />
        <div className="container p-0">
          <GlobalOtkIdAlert />
        </div>
        <Routes />
      </div>
      <Alert />
    </BrowserRouter>
  </Provider>
)

export default App
